import { Linkedin } from "lucide-react";

const links = [
  { label: "What we do", href: "#offerings" },
  { label: "About", href: "#about" },
  { label: "FAQ", href: "#faq" },
];

const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-cream border-t border-ink/15"
    >
      <div className="mx-auto max-w-[1400px] px-5 md:px-8 lg:px-12 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <a
              href="#top"
              className="font-display font-black text-3xl md:text-4xl tracking-tight text-ink flex items-center gap-1"
              data-testid="footer-logo"
            >
              RCS Labs<span className="text-money">.</span>
            </a>
            <a
              href="mailto:divyat@rcslabs.in"
              data-testid="footer-email"
              className="mt-5 inline-block font-mono text-sm uppercase tracking-[0.15em] text-ink underline underline-offset-4 hover:bg-acid"
            >
              divyat@rcslabs.in
            </a>
          </div>

          <div className="md:col-span-3">
            <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-ink/45 mb-4">
              Navigate
            </div>
            <ul className="space-y-3">
              {links.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="font-sans-pro text-sm text-ink/80 hover:text-ink hover:underline underline-offset-4"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-ink/45 mb-4">
              Connect
            </div>
            <a
              href="https://www.linkedin.com/in/divyat-rungta-6441333a/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-linkedin"
              className="inline-flex items-center gap-3 border border-ink text-ink px-4 py-2.5 font-mono text-xs uppercase tracking-[0.18em] hover:bg-ink hover:text-cream transition-colors duration-300"
            >
              <Linkedin className="w-4 h-4" />
              LinkedIn
            </a>
            <p className="mt-5 font-sans-pro text-sm text-ink/65 max-w-xs leading-relaxed">
              Based between India &amp; UAE.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
